<mat-toolbar class="header shadow-lg p-3 d-flex justify-content-between align-items-center">
  <!-- mb-5 -->
  <div class="d-flex justify-content-between align-items-center ">
      <div class="header__title">
        @if (isOnHomeSubpageCRUX || isOnHomeSubpageRUM) {
        <span class="header__title-button" (click)="openMenu()">
          <mat-icon  class="d-flex justify-content-center align-items-center mx-1 ">
            {{ isMenuOpened ? 'arrow_back_ios' : 'arrow_forward_ios' }}
          </mat-icon>
        </span>
        }
        <div class="header__logo-container hover-zoom" (click)="navigateTo()">
          <img
            [src]="
              'data:image/png;base64,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'
            "
            alt="logo"
            class="header__logo"
          />
          <h3 class="header__title-text d-none d-md-block">Speetals</h3>
        </div>

      </div>

  </div>

  <div class="large-screen-content">
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex justify-content-center align-items-center px-3 py-1 mx-3 fs-6">
        <div [style]="isCruxPage ? 'font-weight: bold; font-size: larger' : ''">
          <a (click)="navigateBetween('crux')"style="text-decoration: none; cursor: pointer" >
            <span >CrUX data</span>
          </a>
        </div>
        <div style="margin-left: 1%; margin-right: 1%">
          <span style="color: white">|</span>
        </div>
        <div [style]="isRumPage ? 'font-weight: bold; font-size: larger' : ''">
          <a (click)="navigateBetween('rum')"  style="text-decoration: none; cursor: pointer" class="d-flex justify-content-between align-items-center">
            <span >RUM data</span>
          </a>
        </div>
      </div>
      <div class="header-toolbar d-flex justify-content-center align-items-center  ">

          <div class=" d-flex justify-content-center align-items-center mx-2">
          <div class="mx-2">
            <a
            [routerLink]="'/home/pageLoad/new'"
                    routerLinkActive="router-link-active"
            style="text-decoration: none; cursor: pointer"
            class="add-button d-flex justify-content-center align-items-center bg-primary px-2  rounded-3">
            <mat-icon>add</mat-icon>
              <span style="font-size: 16px">Add website</span>
            </a>
          </div>
          </div>
          <app-search></app-search>
          <app-notifications></app-notifications>
          <app-email [emails]="emails$ | async"></app-email>
          <ng-container *ngIf="user">
            <app-user [user]="user" (signOut)="signOut()"></app-user>
          </ng-container>
      </div>
    </div>

  </div>

  <div class="small-screen-content">
    <div class="d-flex justify-content-start align-items-center mx-4">
        <app-search></app-search>
        <app-notifications></app-notifications>
            <button class="btn btn-primary" [matMenuTriggerFor]="menu"  >
              <div class="d-flex justify-content-center align-items-center w-100">
                <mat-icon>menu</mat-icon>
              </div>
            </button>
            <mat-menu #menu="matMenu" autoClose="false">
              <div mat-menu-item class="d-flex flex-row justify-content-center align-items-center fs-6 w-100 mb-2">
                <div [style]="isCruxPage ? 'font-weight: bold; font-size: larger' : ''">
                  <a (click)="navigateBetween('crux')"style="text-decoration: none; cursor: pointer" >
                    <span class="text-dark" >CrUX data</span>
                  </a>
                </div>
                <div style="margin-left: 1%; margin-right: 1%" class="d-flex justify-content-center align-items-center">
                  <span style="color: rgb(0, 0, 0)">-</span>
                </div>
                <div [style]="isRumPage ? 'font-weight: bold; font-size: larger' : ''">
                  <a (click)="navigateBetween('rum')"  style="text-decoration: none; cursor: pointer" class="d-flex justify-content-between align-items-center">
                    <span class="text-dark">RUM data</span>
                  </a>
                </div>
              </div>
              <mat-divider ></mat-divider>
                <div mat-menu-item class="justify-content-center" (click)="$event.stopPropagation()"  >
                  <a [routerLink]="'/home/pageLoad/new'" style="text-decoration: none">
                    <mat-list-item
                      routerLinkActive="router-link-active"
                      [routerLinkActiveOptions]="{ exact: true }"
                      class="p-0 d-flex justify-content-start align-items-center w-100"
                    >
                      <div class="m-3 d-flex justify-content-start align-items-center">
                        <mat-icon class="text-dark">add</mat-icon>
                        <span class="text-dark text-center">Add website</span>
                      </div>
                    </mat-list-item>
                  </a>
                </div>
                <mat-divider ></mat-divider>
                <div mat-menu-item (click)="$event.stopPropagation()" >
                  <ng-container *ngIf="user">
                    <a [routerLink]="'/home/myAccount'" style="text-decoration: none">
                      <mat-list-item routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="p-0 d-flex justify-content-start align-items-center">
                        <div class="m-3 d-flex justify-content-start align-items-center">
                          <mat-icon class="text-dark">account_circle</mat-icon>
                          <span class="text-dark">My Account</span>
                        </div>
                      </mat-list-item>
                    </a>
                  </ng-container>
                </div>
                <mat-divider ></mat-divider>
                <div mat-menu-item (click)="$event.stopPropagation()" class="d-flex justify-content-center align-items-center" >
                  <ng-container *ngIf="user" >
                    <a (click)="clearData()" style="text-decoration: none">
                      <mat-list-item class="p-0 d-flex justify-content-start align-items-center w-100">
                        <div class="m-3 d-flex justify-content-start align-items-center">
                          <mat-icon class="logo-account text-dark">logout</mat-icon>
                          <span class="text-dark">Sign out</span>
                        </div>
                      </mat-list-item>
                    </a>
                  </ng-container>
                </div>
            </mat-menu>
      </div>
  </div>
</mat-toolbar>
